// extracted by mini-css-extract-plugin
module.exports = {"pagination_wrapper":"Pagination_pagination_wrapper__82kxE","pagination":"Pagination_pagination__NqJo2","pagination_item":"Pagination_pagination_item__8WgfW"};